import React, { useEffect, useState, useContext } from 'react'
import { Col, Row, Input, List, Button } from 'antd'
import PosPaymentModal from './PosPaymentModal'
import { Context } from '../../../context'
import PosSrc from '../PosSrc'

function PosPaymentProject(props) {
  const [state] = useContext(Context)
  const [clientName, setClientName] = useState('')
  const [nit, setNit] = useState(null)
  const [address, setAddress] = useState(null)
  const [phone] = useState(null)
  const [email] = useState(null)
  const [clientsList, setClientsList] = useState([])
  const [visible, setVisible] = useState(null)
  const initDataSource = JSON.stringify([{ id: 1, note: '' }])
  const [dataSource, setDataSource] = useState(JSON.parse(initDataSource))
  const [origenMotivo, setOrigenMotivo] = useState(props.projectData.origin_reason ? props.projectData.origin_reason : '')
  const [destinoMotivo, setDestinoMotivo] = useState(props.projectData.destination_reason ? props.projectData.destination_reason : '')

  useEffect(() => {
    if (props.projectData?.notes && JSON.parse(props.projectData?.notes).length > 0) {
      const data = JSON.parse(props.projectData?.notes).map((p, i) => {
        const obj = {
          id: i,
          note: p
        }
        return obj
      })
      setDataSource(data)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (props.saveSell) {
      let validate = true

      let items = []
      if (props.projectData?.products && props.projectData.products.length > 0) {
        items = props.productsList.map(p => {
          if (!p.product) return null
          return {
            id: p.product,
            quote_id: p.quote_id,
            status: p.status,
            notes: p.notes,
            quantity: parseFloat(p.units),
            unit_price: parseFloat(p.price),
            type: p.type,
            discount_id: p.discount_id,
            discount_amount: p.discount_amount
          }
        })
      } else {
        items = props.productsList.map(p => {
          if (!p.product) return null
          return {
            id: p.product,
            quote_id: p.quote_id,
            status: p.status,
            notes: p.notes,
            quantity: parseFloat(p.units),
            unit_price: parseFloat(p.price),
            type: p.type,
            discount_id: p.discount_id,
            discount_amount: p.discount_amount
          }
        })
      }

      const notes = dataSource.map((item) => {
        return item.note;
      });

      let data = {
        store_id: props.store.id,
        store_turn_id: state.turn.id,
        origin_reason: origenMotivo,
        destination_reason: destinoMotivo,
        name: clientName,
        nit: nit,
        address: address,
        phone: phone,
        email: email,
        items: items.filter(i => i),
        notes: notes,
        id: props.projectData.id ? props.projectData.id : null,
        status: props.projectData.status ? props.projectData.status : null
      }

      props.closeProject(data, validate)
    } else {
      props.sellUnsaved && props.sellUnsaved()
    }
    // eslint-disable-next-line
  }, [props.saveSell])

  useEffect(() => {
    setClientInputsToCF()
    // eslint-disable-next-line
  }, [])

  const addClient = data => {
    setClientsList([...clientsList, data])
    setVisible(false)
  }

  const setClientInputsToCF = async () => {
    let posSrc = null

    try {
      posSrc = await PosSrc.getStore(props.store.id)
    } catch (error) {
      console.log(error);
    }

    if (!(props.total >= 10000 && posSrc.company.country.name === 'Honduras')) {
      setNit('CF')
      setClientName('Cliente final')
      setAddress('Ciudad')
    }
  }

  const onAdd = () => {
    if (dataSource.length > 2) return

    setDataSource(prevState => {
      const sorted = prevState.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id + 1 })
      return [...sorted, newRow]
    })
  }

  const onDelete = (e, rowId) => {
    if (dataSource.length === 1) return

    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))
      return value
    })
  }

  const onSetNotes = (value, rowId) => {
    const newDataSource = dataSource.map(row => {
      if (row.id === rowId) {
        return Object.assign(row, { note: value })
      }
      return row
    })

    setDataSource(newDataSource)
  }

  return (
    <>
      <PosPaymentModal visible={visible} addClient={addClient} visibleStatus={status => setVisible(status)} />
      <h4 className={'section-space-list-bottom'}>{props.edit ? 'Pago de cuenta por cobrar' : 'Detalles del proyecto'}</h4>
      <Row gutter={16}>
        <Col sm={24}>
          <div className={'title-space-field'}>Origen/Motivo</div>
          <Input
            value={origenMotivo}
            onChange={e => setOrigenMotivo(e.target.value)}
            size={'large'}
            placeholder="Origen/Motivo"
          />
        </Col>
        <Col sm={24}>
          <div className={'title-space-field'}>Destino/Motivo</div>
          <Input
            value={destinoMotivo}
            onChange={e => setDestinoMotivo(e.target.value)}
            size={'large'}
            placeholder="Destino/Motivo"
          />
        </Col>
        <Col sm={24}>
          <h4 className={'section-space-list-bottom'}></h4>
        </Col>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className={'title-space-field'}>Notas:</div>
          <List
            id={'inventory-list'}
            size="large"
            rowKey="id"
            dataSource={dataSource}
            renderItem={(row, i) => (
              <List.Item>
                <Row gutter={16} align="bottom" className={'section-space-field w-100'} key={row.id}>
                  <Col sm={1}>
                    <div className={'title-space-bottom text-bold'}>{i + 1}</div>
                  </Col>
                  <Col sm={22}>
                    <Input value={row.note} onChange={e => onSetNotes(e.target.value, row.id)} placeholder={'Escribir Notas'} size={'large'} />
                  </Col>
                  <Col sm={1} className={'center-flex-div'}>
                    <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                      Eliminar
                    </Button>
                  </Col>
                </Row>
              </List.Item>
            )}
            footer={
              <Row gutter={16} className={'section-space-field'}>
                <Col sm={1}></Col>
                <Col sm={9}>
                  <div className="title-tendero dashed-border-button" onClick={onAdd}>
                    <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                      <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                    </svg>
                    <span className={'text'}>Agregar Nota</span>
                  </div>
                </Col>
              </Row>
            }
          />
        </Col>
      </Row>
    </>
  )
}

export default PosPaymentProject
